import React, { lazy } from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ProtectedRoute from '../ProtectedRoute'; // Adjust the import path as needed
// import CreateClient from '../components/pagecomponents/role/createClient';
const Index = lazy(() => import('../pages/Index'));
const Sample = lazy(() => import('../pages/Sample'));
const ProductionTemp = lazy(() => import('../pages/Production/ProductionTemplate'));
const InventoryMgmt = lazy(() => import('../pages/Production/InventoryMgmt'));
const NewTemplate = lazy(() => import('../pages/Production/NewProdTemplate'));
const Login = lazy(() => import('../pages/login'));
const ExpiredPassword = lazy(() => import('../pages/ExpiredPassword'));
const ProfilePage = lazy(() => import('../pages/ProfilePage'));
const CreateUser = lazy(() => import('../pages/userDetails/createUser'));
const CreateRole = lazy(() => import('../pages/role/createRole'));
const CreatePermission = lazy(() => import('../pages/permission/createpermission'));
const AllUser = lazy(() => import('../pages/userDetails/allUser'));
const Allpermission = lazy(() => import('../pages/permission/allpermission'));
const RoleDetails = lazy(() => import('../pages/role/roledetails')); // Import RoleDetails component
const QualityAuditorMainTab = lazy(() => import('../pages/Dashboard/QualityAuditorMainTab.js'));
const CreateClient = lazy(() => import('../pages/client/createClient'));
const ClientDetails = lazy(() => import('../pages/client/clientDetails'));
const ScopetDetails = lazy(() => import('../pages/scope/scopeDetails'));
const UpdateScope = lazy(() => import('../pages/scope/updateScope'));
const UpdateClient = lazy(() => import('../pages/client/updateClient'));
const CreateNewTemplate = lazy(() => import('../pages/template/createNewTemplate'));
const AllocationReallocation = lazy(() => import('../pages/Production/AllocationReallocation'));
const AllocationReallocationType2 = lazy(() => import('../pages/Production/AllocationReallocationType2.js'));
const OutputFileGeneration = lazy(() => import('../pages/Production/OutputFile.js'));
const DefineWizardComp = lazy(() =>
  import('../components/pagecomponents/productionPageComp/ProductionTemplComp/DefineWizardComp')
);
const NewProdTemplateWizardComp = lazy(() =>
  import('../components/pagecomponents/productionPageComp/ProductionTemplComp/NewProdTemplateWizardComp')
);
const EmployeeLevel = lazy(() => import('../pages/Production/RampTarget/RampTargetSearch/EmployeeLevel'));
const ScopeLevel = lazy(() => import('../pages/Production/RampTarget/RampTargetSearch/ScopeLevel'));
const RampTargetEditEmpLevel = lazy(() =>
  import('../components/pagecomponents/productionPageComp/RampTargetSearch/RampTargetEditEmpLevel')
);
const RampAddEditComments = lazy(() =>
  import('../components/pagecomponents/productionPageComp/RampTargetSearch/RampAddEditComments')
);
const AddEditScope = lazy(() => import('../components/pagecomponents/productionPageComp/RampTargetSearch/AddEditScope'));
const FileLogAllocation = lazy(() => import('../pages/Production/FileLogAllocation'));
const FileLogAllocationType2 = lazy(() => import('../pages/Production/FileLogAllocationType2'));
const AllocationFileTemplate = lazy(() => import('../pages/Production/AllocationFileTemplate'));
const FileLogEntry = lazy(() => import('../components/pagecomponents/productionPageComp/AllocatedFileLogsComp/FileLogEntry'));
const EmpDowntimeCapturing = lazy(() => import('../pages/Production/Reports/EmpDowntimeCapturing'));
// const MessengerMain = lazy(() => import('../components/Chats/MessengerMain.js'));

const EndAction = lazy(() => import('../pages/Production/Masters/EndAction'));
const TemplateLogEntry = lazy(() =>
  import('../components/pagecomponents/productionPageComp/AllocationFileTemplateComp/TemplateLogEntry')
);
// const SearchFileLog = lazy(() => import('../pages/Production/SearchFile.js'));
// const SADefectPerUnitTableComp = lazy(() => import('../components/pagecomponents/QualityControl/QASuperAudit/SADefectPerUnit/SADefectPerUnitTableComp'));

//Audit
const AuditorColleagueMapping = lazy(() => import('../pages/QualityControl/Audit/AuditorColleagueMapping'));
const AuditorAuditeeMapping = lazy(() => import('../pages/QualityControl/Audit/AuditorAuditeeMapping'));
const AuditSamplingSearch = lazy(() => import('../pages/QualityControl/Audit/AuditSamplingSearch'));
const AuditReallocation = lazy(() => import('../pages/QualityControl/Audit/AuditReallocation'));
const ViewAllocation = lazy(() => import('../pages/QualityControl/Audit/ViewAllocation'));
const AuditorSearch = lazy(() => import('../pages/QualityControl/Audit/AuditorSearch'));
const WeightageBasedEntry = lazy(() => import('../pages/QualityControl/Audit/WeightageBasedEntry'));
const DefectsPerUnitEntry = lazy(() => import('../pages/QualityControl/Audit/DefectsPerUnitEntry'));
const SuperAuditDefectsPerUnitEntry = lazy(() => import('../pages/QualityControl/SuperAudit/SuperAuditDefectsPerUnitEntry.js'));
const AuditEntryCoding = lazy(() => import('../pages/QualityControl/Audit/AuditEntryCoding'));
const TemplateManagementMain = lazy(() => import('../pages/QualityControl/Template/TemplateManagementMain'));
const EditQATemplate = lazy(() =>
  import('../components/pagecomponents/QualityControl/TemplateManagementComp/EditQATemplateWizardComp')
);
const NewProdTemplate = lazy(() => import('../pages/QualityControl/Template/NewProdTemplate'));
const UpdateEmployeePerformance = lazy(() => import('../pages/QualityControl/Reports/UpdateEmployeePerformance.js'));
const EmployeeDetails = lazy(() => import('../pages/QualityControl/Reports/EmployeeDetails.js'));
const UpdateEmployeePerformancedata2 = lazy(() => import('../pages/QualityControl/Reports/UpdateEmployeePerformancedata2'));
const QAGenericSampling = lazy(() =>
  import('../components/pagecomponents/QualityControl/QAGenericSamplingComp/QAGenericSampling')
);

const QASuperAuditGenericHeader = lazy(() => import('../pages/QualityControl/SuperAudit/QASuperAuditGenericSampling.js'));
const QAFocusedSampling = lazy(() =>
  import('../components/pagecomponents/QualityControl/QAFocusedSamplingComp/QAFocusedSampling')
);
const AnalyticalTeamReport = lazy(() => import('../pages/QualityControl/Reports/CollegueLevelAuditor/AnalyticalTeamReport'));
const AwascTemp = lazy(() => import('../pages/QualityControl/Reports/CollegueLevelAuditor/AwacsTemp'));
const PerformanceYearlyTrend = lazy(() => import('../pages/QualityControl/Reports/CollegueLevelAuditor/PerformanceYearlyTrend'));
const ReportsEmpPerfDashBoard = lazy(() => import('../pages/Production/Reports/ReportsEmpPerfDashBoard'));
const ReportsEmployeePerformance = lazy(() => import('../pages/Production/Reports/ReportsEmployeePerformance'));
const ReportsAuditorPerformance = lazy(() => import('../pages/Production/Reports/ReportAuditorPerformance.js'));
const InventoryVolumneAnalysis = lazy(() => import('../pages/Production/Reports/InventoryVolumeAnalysis.js'));
// const ProductionVsTargetAnalysis = lazy(() => import('../pages/Production/Reports/ProductionVsTargetAnalysis.js'));
// const ReportsPEPProcess = lazy(() => import('../pages/Production/Reports/ReportsPEPProcess.js'));
const LogReview = lazy(() => import('../pages/Production/LogReview'));
const ErrorListAuditorSearch = lazy(() => import('../pages/QualityControl/SuperAudit/ErrorListAuditorSearch'));
const ErrorListSuperSearchComp = lazy(() => import('../pages/QualityControl/SuperAudit/ErrorListSuperSearch'));
const SupervisorAuditorMapping = lazy(() => import('../pages/QualityControl/SuperAudit/SupervisorAuditorMapping'));
const SAErrorSupervisorView = lazy(() =>
  import('../components/pagecomponents/QualityControl/QASuperAudit/SAAuitorSearch/SAErrorSupervisorView')
);
const SAErrorAuditorView = lazy(() =>
  import('../components/pagecomponents/QualityControl/QASuperAudit/SAAuitorSearch/SAErrorAuditorView')
);
const SAWeightageBased = lazy(() => import('../pages/QualityControl/SuperAudit/SAWeightageBased'));
const SADefectsPerUnit = lazy(() => import('../pages/QualityControl/SuperAudit/SADefectsPerUnit'));
const SAAuditEntryCoding = lazy(() => import('../pages/QualityControl/SuperAudit/SAAuditEntryCoding'));
const QARebuttalErrAuditorSearch = lazy(() => import('../pages/QualityControl/Rebuttal/QARebuttalErrAuditorSearch.js'));
const QARebuttalQAManagerSearch = lazy(() => import('../pages/QualityControl/Rebuttal/QARebuttalQAManagerSearch.js'));
const QAFyiRebuttalQAManagerSearch = lazy(() => import('../pages/QualityControl/Rebuttal/QAFyiRebuttalQAManagerSearch.js'));
const QAReWorkSearch = lazy(() => import('../pages/QualityControl/Rebuttal/QAReworkSearch.js'));
const QAOPSManagerSearch = lazy(() => import('../pages/QualityControl/Rebuttal/QAOPSManagerSearch.js'));
const QAOPSCollegeueSearch = lazy(() => import('../pages/QualityControl/Rebuttal/QAOPSCollegeueSearch.js'));
const QASingleViewSearch = lazy(() => import('../pages/QualityControl/Rebuttal/QASingleViewSearch.js'));
const QARebuttalSingleView = lazy(() =>
  import('../components/pagecomponents/QualityControl/RebuttalComp/QASingleViewComp/QARebuttalSingleView.js')
);
const QARebuttalErrAuditorView = lazy(() =>
  import('../components/pagecomponents/QualityControl/RebuttalComp/QAAuditViewSearchComp/QARebuttalErrAuditorView.js')
);
const RebuttalAuditQAManagerView = lazy(() =>
  import('../components/pagecomponents/QualityControl/RebuttalComp/QAManagerSearchComp/RebuttalAuditQAManagerView.js')
);
const RebuttalFyiAuditQAManagerView = lazy(() =>
  import('../components/pagecomponents/QualityControl/RebuttalComp/QAManagerSearchComp/RebuttalFyiAuditQAManagerView.js')
);
const QARebuttalReWorkAuditView = lazy(() =>
  import('../components/pagecomponents/QualityControl/RebuttalComp/QAReworkSearch/QARebuttalReWorkAuditView.js')
);
const AddEditScopeQualityCCHS = lazy(() =>
  import('../components/pagecomponents/MasterComp/ScopeComp/ScopeQualityComp/CCHS/AddEditScopeQualityCCHS.js')
);

const RebuttalOPSManagerView = lazy(() =>
  import('../components/pagecomponents/QualityControl/RebuttalComp/QAOPSManagerSearchComp/RebuttalAuditOPSManagerView.js')
);

const RebuttalOPSColleagueView = lazy(() =>
  import('../components/pagecomponents/QualityControl/RebuttalComp/QAOPSColleagueComp/QAOPSColleagueView.js')
);

const RCASearch = lazy(() => import('../pages/Production/CoachingFeedback/RCASearch.js'));
const POASearch = lazy(() => import('../pages/Production/CoachingFeedback/POASearch.js'));
const ARCategorySearch = lazy(() => import('../pages/Production/CoachingFeedback/ARCategorySearch.js'));
const ARSubCategorySearch = lazy(() => import('../pages/Production/CoachingFeedback/ARSubCategorySearch.js'));
const EmployeeLifeCycle = lazy(() => import('../pages/Production/CoachingFeedback/EmployeeLifeCycle.js'));
const EmployeePerformancePage = lazy(() =>
  import('../components/pagecomponents/productionPageComp/CoachingFeedbackComp/EmployeePerformancePage.js')
);
const SearchSupervisor = lazy(() => import('../pages/Production/CoachingFeedback/SearchSupervisor.js'));
const EntryCodingBilling = lazy(() =>
  import('../components/pagecomponents/productionPageComp/CoachingFeedbackComp/EntryCodingBilling.js')
);
const EntryARSupervisor = lazy(() =>
  import('../components/pagecomponents/productionPageComp/CoachingFeedbackComp/EntryARSupervisor.js')
);
const RecognitionRewards = lazy(() => import('../RecognitionRewards/RecognitionRewardsMain.js'));

const SLASummaryDetailsSupervisor = lazy(() => import('../pages/Production/Reports/SLASummaryDetailsSupervisor.js'));
// const SLASummaryDetailsColleague = lazy(() => import('../pages/Production/Reports/SLASummaryDetailsColleague.js'));
const MonthlyQualityReports = lazy(() => import('../pages/QualityControl/Reports/MonthlyQualityReports.js'));
const QualityReportsMain = lazy(() =>
  import('../pages/QualityControl/Reports/CollegueLevelAuditor/QaMailReports/QualityReportsMain.js')
);
const WeeklyQualityReport = lazy(() => import('../pages/QualityControl/Reports/WeeklyQualityReport.js'));
const ActivityTracker = lazy(() => import('../pages/Production/Reports/ActivityTracker.js'));
const MTDAuditCoverage = lazy(() => import('../pages/QualityControl/Reports/MTDAuditCoverage.js'));
const AuditorProductionDetails = lazy(() => import('../pages/QualityControl/Reports/AuditorProductionDetails.js'));
const AuditorProductionSummary = lazy(() => import('../pages/QualityControl/Reports/AuditorProductionSummary.js'));
const AuditorHourlyProduction = lazy(() => import('../pages/QualityControl/Reports/AuditorHourlyProduction.js'));
const WeeklySummary = lazy(() => import('../pages/QualityControl/Reports/WeeklySummary.js'));
const WeeklyProductionQuality = lazy(() => import('../pages/QualityControl/Reports/WeeklyProductionQuality.js'));
const QuaterlyErrorAuditor = lazy(() => import('../pages/QualityControl/Reports/QuaterlyErrorAuditor.js'));
const ProjectScopeWise = lazy(() => import('../pages/QualityControl/Reports/ProjectScopeWise.js'));
const WholeActivity = lazy(() => import('../pages/Production/Reports/WholeActivity.js'));
const ProductivityReport = lazy(() => import('../pages/Production/Reports/ProductivityReport.js'));
const QAReports = lazy(() => import('../pages/QualityControl/Reports/QAReports.js'));
const QADailyReports = lazy(() => import('../pages/QualityControl/Reports/QADailyReports.js'));
const AuditorEfficiency = lazy(() => import('../pages/Production/Reports/AuditorEfficiency.js'));
const InventoryAddEdit = lazy(() =>
  import('../components/pagecomponents/MasterComp/ScopeComp/ScopeProductionComp/InventoryEditandAdd.js')
);

//Routes for Masters
const UserManagement = lazy(() => import('../pages/Masters/UserManagement.js'));
const AddEditUserManagement = lazy(() => import('../components/pagecomponents/MasterComp/UserManagementComp/AddEditUserMgmt.js'));
const UserSearch = lazy(() => import('../components/pagecomponents/MasterComp/UserManagementComp/UserSearch.js'));
const UserViewTab = lazy(() => import('../components/pagecomponents/MasterComp/UserManagementComp/UserViewTab.js'));
const ClientManagement = lazy(() => import('../pages/Masters/ClientManagement.js'));
const ClientSearch = lazy(() => import('../components/pagecomponents/MasterComp/ClientComp/ClientSearch.js'));
const AddEditClientMgmtComp = lazy(() => import('../components/pagecomponents/MasterComp/ClientComp/AddEditClientMgmtComp.js'));
const ClientViewTab = lazy(() => import('../components/pagecomponents/MasterComp/ClientComp/ClientViewTab.js'));
const DivisionManagement = lazy(() => import('../pages/Masters/DivisionManagement.js'));
const EndClientManagement = lazy(() => import('../pages/Masters/EndClientManagement.js'));
const ScopeManagement = lazy(() => import('../pages/Masters/ScopeManagement.js'));
const AddEditScopeComp = lazy(() => import('../components/pagecomponents/MasterComp/ScopeComp/AddEditScopeComp.js'));
const ScopeViewComp = lazy(() => import('../components/pagecomponents/MasterComp/ScopeComp/ScopeViewComp.js'));
const ErrorCategory = lazy(() =>
  import('../components/pagecomponents/MasterComp/ScopeComp/ScopeQualityComp/ErrorSubCat/ErrorCategory.js')
);
const ErrorSubCategory = lazy(() =>
  import('../components/pagecomponents/MasterComp/ScopeComp/ScopeQualityComp/ErrorSubCat/ErrorSubCategory.js')
);
// const PermissionConfiguration = lazy(() => import('../pages/Masters/PermissionConfiguration.js'));
// const Permissiongrouping = lazy(() => import('../components/pagecomponents/MasterComp/PermissionComp/Permissiongrouping.js'));
const AddEditPBIMain = lazy(() =>
  import('../components/pagecomponents/MasterComp/ScopeComp/ScopeQualityComp/PBI/AddEditPBIMain.js')
);
const AddEditWeeklyMOM = lazy(() =>
  import('../components/pagecomponents/MasterComp/ScopeComp/ScopeQualityComp/WeeklyMOM/AddEditWeeklyMOM.js')
);
const CalibrationAssignment = lazy(() =>
  import('../components/pagecomponents/MasterComp/ScopeComp/ScopeQualityComp/Caliberation/AddEditCalibrationAssignment.js')
);
const AddEditCalibrationPlan = lazy(() =>
  import('../components/pagecomponents/MasterComp/ScopeComp/ScopeQualityComp/Caliberation/AddEditCalibrationPlan.js')
);
const RolesManagement = lazy(() => import('../pages/Masters/RolesManagement.js'));
const AuditEmployeeErrorTab = lazy(() =>
  import('.././components/pagecomponents/QualityControl/Audit/WeightageBasedEntry/AuditEmployeeErrorTab.js')
);

//Dashboard
const UserLevelDashboards = lazy(() => import('../pages/Dashboard/UserLevelMainTab.js'));
const AMDMMainTab = lazy(() => import('../pages/Dashboard/AMDMMainTab.js'));

const SuperAuditSamplingSearch = lazy(() => import('../pages/QualityControl/SuperAudit/SuperAuditSamplingSearch.js'));
const SuperAuditEntrySearch = lazy(() => import('../pages/QualityControl/SuperAudit/SuperAuditEntrySearch.js'));
const SuperAuditRebuttalMainFile = lazy(() =>
  import('../pages/QualityControl/SuperAudit/superAuditRebuttal/superAuditRebuttalMainFile.js')
);
const SuperAuditRebuttalView = lazy(() =>
  import('../pages/QualityControl/SuperAudit/superAuditRebuttal/superAuditRebuttalView.js')
);
const MainReports = lazy(() => import('../components/pagecomponents/BiReports/MainReports.js'));
const SuperAuditFyiStatusRebuttalMainFile = lazy(() =>
  import('../pages/QualityControl/SuperAudit/superAuditFyiStatusRebuttal/superAuditRebuttalMainFile.js')
);
const RebuttalSuperAuditFyiStatusView = lazy(() =>
  import('../pages/QualityControl/SuperAudit/superAuditFyiStatusRebuttal/superAuditRebuttalView.js')
);
const SuperAuditDailyReport = lazy(() =>
  import('../pages/QualityControl/SuperAudit/superAuditReports/SuperAuditDailyReports.js')
);
const QMDashboardMain = lazy(() =>
  import('../components/pagecomponents/DashboardComp/QualityManagerDashboard/QMDashboardMain.js')
);
//Apps
const PasswordManager = lazy(() =>
  import('../components/pagecomponents/MasterComp/ScopeComp/PasswordManager/PasswordManager.js')
);
const CreatePassword = lazy(() => import('../components/pagecomponents/MasterComp/ScopeComp/PasswordManager/CreatePassword.js'));
const EditPassword = lazy(() => import('../components/pagecomponents/MasterComp/ScopeComp/PasswordManager/EditPassword.js'));
const ClientProtocols = lazy(() => import('../components/pagecomponents/MasterComp/ScopeComp/ClientProtocol/ClientProtocols.js'));
// const Incentive = lazy(() => import('../components/Layouts/context/Incentive/Incentive.js'));
const Ratings = lazy(() => import('../components/Layouts/context/Incentive/Ratings.js'));
const AssistantManagerRatings = lazy(() => import('../components/Layouts/context/Incentive/AssistantManagerRatings'));
const EmptyPage = lazy(() => import('../test/EmptyPage.js'));
const ArCategoryException = lazy(() => import('../pages/Masters/ArCategoryException/ArCategoryExceptionMain.js'));
const ArCategoryExceptionAudit = lazy(() => import('../pages/Masters/ArCategoryExceptionAudit/ArCategoryExceptionMainAudit.js'));

const AwardCategory = lazy(() => import('../RecognitionRewards/AwardCategoryMain.js'));
const RedeemMain = lazy(() => import('../RecognitionRewards/RedeemMain.js'));
const EmployeRewards = lazy(() => import('../RecognitionRewards/EmployeRewards.js'));

const SuperAuditMTDReport = lazy(() => import('../pages/QualityControl/SuperAudit/superAuditReports/SuperAuditMTD.js'));
const WorkForceManagement = lazy(() => import('../pages/Masters/WorkForceManagement.js'));
const EprWhiteList = lazy(() => import('../components/EprWhiteList/EprWhiteList.js'));
const Ticket = lazy(() => import('../components/UtilitiesComponents/EprTicket/Ticket.js'));
const Holiday = lazy(() => import('../components/UtilitiesComponents/Holiday/Holiday.js'));
const PublicTop5Carousel = lazy(() => import('../pages/PublicTop5Carousel'));
const DailyTracker = lazy(() => import('../components/pagecomponents/QualityControl/DailyTracker/DailyTracker.js'));
// const UnifiedContactProfile = lazy(() => import('../RecognitionRewards/UnifiedContactProfile.js'));
const EmployeeIndividualLevel = lazy(() => import('../pages/Production/RampTarget/RampTargetSearch/EmployeeIndividualLevel'));
const AssitantMangerAuditorError = lazy(() => import('../pages/QualityControl/AssitantMangerAuditorError/AssitantMangerAuditorError'));
export const routes = [
  { path: '/login', element: <Login />, layout: 'blank' },
  { path: '/users/profile', element: <ProfilePage /> },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <Index />
      </ProtectedRoute>
    ),
  },
  {
    path: '/pages/Sample',
    element: (
      <ProtectedRoute>
        <Sample />
      </ProtectedRoute>
    ),
  },
  {
    path: '/Production/ProductionTemplate',
    element: (
      <>
        <ProductionTemp />
      </>
    ),
  },
  {
    path: '/Production/InventoryMgmt',
    element: (
      <>
        <InventoryMgmt />
      </>
    ),
  },
  { path: '/Production/ProductionTemplate/NewProdTemplate', element: <NewTemplate /> },
  {
    path: '/user/createUser',
    element: (
      <>
        <CreateUser />
      </>
    ),
  },
  {
    path: '/User/role',
    element: (
      <>
        <CreateRole />
      </>
    ),
  },
  {
    path: '/User/createpermission',
    element: (
      <>
        <CreatePermission />
      </>
    ),
  },
  {
    path: '/User/allUser',
    element: (
      <>
        <AllUser />
      </>
    ),
  },
  {
    path: '/User/allpermission',
    element: (
      <>
        <Allpermission />
      </>
    ),
  },
  {
    path: '/User/roledetails',
    element: (
      <>
        <RoleDetails />
      </>
    ),
  },
  {
    path: '/createClient',
    element: (
      <>
        <CreateClient />
      </>
    ),
  },
  {
    path: '/ClientDetails',
    element: (
      <>
        <ClientDetails />
      </>
    ),
  },
  {
    path: '/ScopeDetails',
    element: (
      <>
        <ScopetDetails />
      </>
    ),
  },
  {
    path: '/updateScope/:id',
    element: (
      <>
        <UpdateScope />
      </>
    ),
  },
  {
    path: '/updateClient/:clientId',
    element: (
      <>
        <UpdateClient />
      </>
    ),
  },
  {
    path: '/CreateNewTemplate',
    element: (
      <>
        <CreateNewTemplate />
      </>
    ),
  },
  {
    path: '/production/AllocationReallocation',
    element: (
      <>
        <AllocationReallocation />
      </>
    ),
  },
  {
    path: '/production/AllocationReallocationType2',
    element: (
      <>
        <AllocationReallocationType2 />
      </>
    ),
  },
  {
    path: '/Production/AllocationFilesTemplate',
    element: (
      <>
        <AllocationFileTemplate />
      </>
    ),
  },
  {
    path: '/Production/AllocationFilesTemplate/AddEditAlloFileLogEntry',
    element: (
      <>
        <FileLogEntry />
      </>
    ),
  },
  {
    path: '/Production/AllocationFilesTemplate/AddEditAlloTemplateLogEntry',
    element: (
      <>
        <TemplateLogEntry />
      </>
    ),
  },
  {
    path: '/Production/OutputFileGeneration',
    element: (
      <>
        <OutputFileGeneration />
      </>
    ),
  },
  {
    path: '/DefineWizardComp',
    element: (
      <>
        <DefineWizardComp />
      </>
    ),
  },
  {
    path: '/NewProdTemplateWizardComp',
    element: (
      <>
        <NewProdTemplateWizardComp />
      </>
    ),
  },
  {
    path: '/RampTargetSearch/ScopeLevel',
    element: (
      <>
        <ScopeLevel />
      </>
    ),
  },
  {
    path: '/RampTargetSearch/EmployeeLevel',
    element: (
      <>
        <EmployeeLevel />
      </>
    ),
  },
  {
    path: '/RampTargetSearch/EmployeeIndividualLevel',
    element: (
      <>
        <EmployeeIndividualLevel />
      </>
    ),
  },
  // {
  //   path: '/Production/SearchFileLogs',
  //   element: (
  //     <>
  //       <SearchFileLog />
  //     </>
  //   ),
  // },
  {
    path: '/RampTargetSearch/EmployeeLevel/EditEmpLevel',
    element: <RampTargetEditEmpLevel />,
    layout: 'default',
  },
  {
    path: '/RampTargetSearch/EmployeeLevel/AddEditCommentsEmpLevel',
    element: <RampAddEditComments />,
    layout: 'default',
  },
  {
    path: '/ScopeLevel/AddEditScope',
    element: <AddEditScope />,
    layout: 'default',
  },

  {
    path: '/NewProdTemplateWizardComp',
    element: (
      <>
        <NewProdTemplateWizardComp />
      </>
    ),
  },
  {
    path: '/Production/FileLogAllocation',
    element: (
      <>
        <FileLogAllocation />
      </>
    ),
  },
  {
    path: '/Production/FileLogAllocationType2',
    element: (
      <>
        <FileLogAllocationType2 />
      </>
    ),
  },
  {
    path: '/Production/Logreview',
    element: <LogReview />,
    layout: 'default',
  },
  {
    path: '/Production/AllocationFilesTemplate/AddEditAlloFileLogEntry',
    element: <FileLogEntry />,
    layout: 'default',
  },
  {
    path: '/Production/Reports/EmpPerformance',
    element: <ReportsEmployeePerformance />,
    layout: 'default',
  },
  {
    path: '/Production/Reports/EmpPerformanceDashboard',
    element: <ReportsEmpPerfDashBoard />,
    layout: 'default',
  },
  {
    path: '/Production/Reports/EmpDowntimeCap',
    element: <EmpDowntimeCapturing />,
    layout: 'default',
  },

  {
    path: '/Production/EndAction',
    element: <EndAction />,
  },
  {
    path: '/Production/Reports/EmpPerformance',
    element: <ReportsEmployeePerformance />,
    layout: 'default',
  },

  {
    path: '/Production/Reports/InventoryVolAnalysis',
    element: <InventoryVolumneAnalysis />,
    layout: 'default',
  },

  {
    path: '/QualityControl/Audit/AuditSamplingSearch', //audit
    element: <AuditSamplingSearch />,
    layout: 'default',
  },

  {
    path: '/QualityControl/Audit/SuperAuditSamplingSearch', //audit
    element: <SuperAuditSamplingSearch />,
    layout: 'default',
  },

  {
    path: '/QualityControl/Audit/AuditorAuditeeMapping', //audit
    element: <AuditorAuditeeMapping />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Audit/Reallocation', //audit
    element: <AuditReallocation />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Audit/ViewAllocation', //audit
    element: <ViewAllocation />,
    layout: 'default',
  },
  {
    path: '/QualityControl/AuditorColleagueMap', //audit
    element: <AuditorColleagueMapping />,
    layout: 'default',
  },
  {
    path: '/QualityControl/AuditSamplingSearch/QAGeneSampling',
    element: <QAGenericSampling />,
    layout: 'default',
  },
  {
    path: '/QualityControl/SuperAuditSamplingSearch/QASuperAuditGeneSampling',
    element: <QASuperAuditGenericHeader />,
    layout: 'default',
  },
  {
    path: '/QualityControl/AuditSamplingSearch/QAFocusedSampling',
    element: <QAFocusedSampling />,
    layout: 'default',
  },

  {
    path: '/QualityControl/Audit/AuditorSearch',
    element: <AuditorSearch />,
    layout: 'default',
  },

  {
    path: '/QualityControl/Audit/SuperAuditSearch',
    element: <SuperAuditEntrySearch />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Audit/Entry/WeightageBased',
    element: <WeightageBasedEntry />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Audit/Entry/DefectsPerUnit',
    element: <DefectsPerUnitEntry />,
    layout: 'default',
  },

  {
    path: '/QualityControl/SuperAudit/Entry/SuperAuditDefectsPerUnitEntry',
    element: <SuperAuditDefectsPerUnitEntry />,
    layout: 'default',
  },

  {
    path: '/QualityControl/Audit/Entry/EntryCoding',
    element: <AuditEntryCoding />,
    layout: 'default',
  },
  // {
  //   path: '/QualityControl/SuperAudit/Entry/EntrySearch',
  //   element: <EntrySearch />,
  //   layout: 'default',
  // },
  {
    path: '/QualityControl/SuperAudit/Entry/SAWeightageBased',
    element: <SAWeightageBased />,
    layout: 'default',
  },
  {
    path: '/QualityControl/SuperAudit/Entry/SADefectsPerUnit',
    element: <SADefectsPerUnit />,
    layout: 'default',
  },
  // {
  //   path: '/QualityControl/QASuperAudit/SADefectPerUnitTableComp',
  //   element: <SADefectPerUnitTableComp />,
  //   layout: 'default',
  // },
  {
    path: '/QualityControl/Audit/Entry/SAAuditEntry',
    element: <SAAuditEntryCoding />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Template/TemplateManagement',
    element: <TemplateManagementMain />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Template/TemplateManagement/NewProdTemplate',
    element: <NewProdTemplate />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Template/TemplateManagement/EditQATemplate',
    element: <EditQATemplate />,
    layout: 'default',
  },
  {
    path: '/QualityControl/SuperAudit/Error/AuditorSearchList',
    element: <ErrorListAuditorSearch />,
    layout: 'default',
  },
  {
    path: '/QualityControl/SuperAudit/Error/SupervisorSearchList',
    element: <ErrorListSuperSearchComp />,
    layout: 'default',
  },
  {
    path: '/QualityControl/SuperAudit/Error/SupervisorView',
    element: <SAErrorSupervisorView />,
    layout: 'default',
  },
  {
    path: '/QualityControl/SuperAudit/Error/AuditorView',
    element: <SAErrorAuditorView />,
    layout: 'default',
  },
  {
    path: '/QualityControl/SuperAudit/SupervisorAuditorMapping',
    element: <SupervisorAuditorMapping />,
    layout: 'default',
  },
  {
    path: '/CollLevelReport/AnalyTeamReport',
    element: <AnalyticalTeamReport />,
    layout: 'default',
  },
  {
    path: '/CollLevelReport/AWASTeamReport',
    element: <AwascTemp />,
    layout: 'default',
  },
  {
    path: '/CollLevelReport/YearlyTrending',
    element: <PerformanceYearlyTrend />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Rebuttal/ErrorAuditorSearch',
    element: <QARebuttalErrAuditorSearch />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Rebuttal/ErrorQAManagerSearch',
    element: <QARebuttalQAManagerSearch />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Rebuttal/QAFyiManagerSearch',
    element: <QAFyiRebuttalQAManagerSearch />,
    layout: 'default',
  },

  {
    path: '/QualityControl/Rebuttal/QAReWorkManagerSearch',
    element: <QAReWorkSearch />,
    layout: 'default',
  },

  {
    path: '/QualityControl/Rebuttal/ErrorOPSManagerSearch',
    element: <QAOPSManagerSearch />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Rebuttal/ErrorOPSColleagueSearch',
    element: <QAOPSCollegeueSearch />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Rebuttal/SingleViewSearch',
    element: <QASingleViewSearch />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Rebuttal/SingleViewSearch/SingleView',
    element: <QARebuttalSingleView />,
    layout: 'default',
  },

  {
    path: '/QualityControl/Rebuttal/AuditorView',
    element: <QARebuttalErrAuditorView />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Rebuttal/QAManagerSearch/QAManagerView',
    element: <RebuttalAuditQAManagerView />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Rebuttal/QAManagerSearch/RebuttalFyiAuditQAManagerView',
    element: <RebuttalFyiAuditQAManagerView />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Rebuttal/QAManagerSearch/QARebuttalReWorkAuditView',
    element: <QARebuttalReWorkAuditView />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Rebuttal/QAOPSManagerSearch/QAOPSManagerView',
    element: <RebuttalOPSManagerView />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Rebuttal/QAOPSColleagueSearch/QAOPSColleagueView',
    element: <RebuttalOPSColleagueView />,
    layout: 'default',
  },

  {
    path: '/Production/CoachingFeedback/RCASearch',
    element: <RCASearch />,
    layout: 'default',
  },
  {
    path: '/Production/CoachingFeedback/POASearch',
    element: <POASearch />,
    layout: 'default',
  },
  {
    path: '/Production/CoachingFeedback/AREvaluationCatSearch',
    element: <ARCategorySearch />,
    layout: 'default',
  },
  {
    path: '/Production/CoachingFeedback/AREvaluationSubCatSearch',
    element: <ARSubCategorySearch />,
    layout: 'default',
  },
  {
    path: '/Production/CoachingFeedback/SearchSupervisor',
    element: <SearchSupervisor />,
    layout: 'default',
  },
  {
    path: '/Production/CoachingFeedback/EmpLifeCycle',
    element: <EmployeeLifeCycle />,
    layout: 'default',
  },
  {
    path: '/Production/CoachingFeedback/Employee-life-cycle/:employeeId',
    element: <EmployeePerformancePage />,
    layout: 'default',
  },
  {
    path: '/Production/CoachingFeedback/SearchSupervisor/BillingSupervisor',
    element: <EntryCodingBilling />,
    layout: 'default',
  },
  {
    path: '/Production/CoachingFeedback/SearchSupervisor/ARSupervisor',
    element: <EntryARSupervisor />,
    layout: 'default',
  },
  // {
  //   path: '/Production/Reports/PEPProcess',
  //   element: <ReportsPEPProcess />,
  //   layout: 'default',
  // },
  {
    path: '/Production/Reports/AuditorPerformance',
    element: <ReportsAuditorPerformance />,
    layout: 'default',
  },
  // {
  //   path: '/Production/Reports/ProdVsTarAnalysis',
  //   element: <ProductionVsTargetAnalysis />,
  //   layout: 'default',
  // },
  {
    path: '/Production/Reports/SLASummarySupervisor',
    element: <SLASummaryDetailsSupervisor />,
    layout: 'default',
  },
  // {
  //   path: '/Production/Reports/SLASummaryColleagues',
  //   element: <SLASummaryDetailsColleague />,
  //   layout: 'default',
  // },
  {
    path: '/Production/Reports/ActivityTracker',
    element: <ActivityTracker />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Reports/MTDAudCov',
    element: <MTDAuditCoverage />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Reports/AuditorProdDet',
    element: <AuditorProductionDetails />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Reports/AuditorProdSummary',
    element: <AuditorProductionSummary />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Reports/AuditorHrlyProd',
    element: <AuditorHourlyProduction />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Reports/WeeklyProdQtlyAnalysis',
    element: <WeeklySummary />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Reports/WeeklyProdQultyAnalysis',
    element: <WeeklyProductionQuality />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Reports/MonthlyQutrtErrAuditor',
    element: <QuaterlyErrorAuditor />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Reports/ProjectScopeWise',
    element: <ProjectScopeWise />,
    layout: 'default',
  },
  {
    path: '/Production/Reports/WholeActivity',
    element: <WholeActivity />,
    layout: 'default',
  },
  {
    path: '/Production/Reports/ProductivityReport',
    element: <ProductivityReport />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Reports/QAReports',
    element: <QAReports />,
  },
  {
    path: '/QualityControl/Reports/QADailyReports',
    element: <QADailyReports />,
  },
  {
    path: '/AuditorEfficiency',
    element: <AuditorEfficiency />,
    layout: 'default',
  },
  {
    path: '/QualityControl/Reports/WeeklyQualityReport',
    element: <WeeklyQualityReport />,
  },
  {
    path: '/QualityControl/Reports/MonthlyQualityReports',
    element: <MonthlyQualityReports />,
  },
  {
    path: '/QualityControl/Reports/QualityReportsMain',
    element: <QualityReportsMain />,
  },

  //Routes for Masters
  {
    path: '/UserMgmt',
    element: <UserManagement />,
    layout: 'default',
  },
  {
    path: '/UserMgmt/AddEdit',
    element: <AddEditUserManagement />,
    layout: 'default',
  },
  {
    path: '/UserMgmt/UserSearch',
    element: <UserSearch />,
    layout: 'default',
  },
  {
    path: '/UserMgmt/UserView',
    element: <UserViewTab />,
    layout: 'default',
  },
  {
    path: '/ClientMgmt',
    element: <ClientManagement />,
    layout: 'default',
  },
  {
    path: '/ClientMgmt/ClientSearch',
    element: <ClientSearch />,
    layout: 'default',
  },
  {
    path: '/ClientMgmt/AddEditClient',
    element: <AddEditClientMgmtComp />,
    layout: 'default',
  },
  //'/ClientMgmt/ClientView
  {
    path: '/ClientMgmt/ClientView',
    element: <ClientViewTab />,
    layout: 'default',
  },
  {
    path: '/DivisionMgmt',
    element: <DivisionManagement />,
    layout: 'default',
  },
  {
    path: '/EndClientMgmt',
    element: <EndClientManagement />,
    layout: 'default',
  },
  {
    path: '/ScopeMgmt',
    element: <ScopeManagement />,
    layout: 'default',
  },
  {
    path: '/ScopeMgmt/AddEditNewScope',
    element: <AddEditScopeComp />,
    layout: 'default',
  },
  {
    path: '/ScopeMgmt/ScopeView',
    element: <ScopeViewComp />,
    layout: 'default',
  },
  {
    path: '/ScopeMgmt/AddNewErrorCategory',
    element: <ErrorCategory />,
    layout: 'default',
  },
  {
    path: '/ScopeMgmt/AddEditErrorCategory/ErrorSubCategory',
    element: <ErrorSubCategory />,
    layout: 'default',
  },
  // {
  //   path: '/PermissionConfig',
  //   element: <PermissionConfiguration />,
  //   layout: 'default',
  // },
  // {
  //   path: '/PermissionConfig/PermissionGrouping',
  //   element: <Permissiongrouping />,
  //   layout: 'default',
  // },
  {
    path: '/ScopeMgmt/PBI/AddEditPBI',
    element: <AddEditPBIMain />,
    layout: 'default',
  },
  {
    path: '/ScopeMgmt/Data/Quality/AddEditCCHS',
    element: <AddEditScopeQualityCCHS />,
    layout: 'default',
  },
  {
    path: '/ScopeMgmt/WeeklyMOM/AddEditWeeklyMOM',
    element: <AddEditWeeklyMOM />,
    layout: 'default',
  },
  {
    path: '/ScopeMgmt/Data/Quality/CalibrationAddEdit',
    element: <CalibrationAssignment />,
    layout: 'default',
  },
  {
    path: '/ScopeMgmt/Data/Quality/CalibrationImplementationAddEdit',
    element: <AddEditCalibrationPlan />,
    layout: 'default',
  },
  {
    path: '/RolesMgmt',
    element: <RolesManagement />,
    layout: 'default',
  },
  {
    path: '/ScopeMgmt/ScopeData/InventoryAddEdit',
    element: <InventoryAddEdit />,
    layout: 'default',
  },
  {
    path: '/QualityAuditor',
    element: <QualityAuditorMainTab />,
    layout: 'default',
  },
  {
    path: '/Audit/AuditEmployeeErrorStatus/AuditEmployeeErrorTab',
    element: (
      <>
        <AuditEmployeeErrorTab />
      </>
    ),
  },
  //Dashboard
  {
    path: '/UserLevel',
    element: <UserLevelDashboards />,
    layout: 'default',
  },
  {
    path: '/AMDM',
    element: <AMDMMainTab />,
    layout: 'default',
  },
  {
    path: '/UpdateEmployeePerformancedata',
    element: <UpdateEmployeePerformance />,
    layout: 'default',
  },
  {
    path: '/EmployeeDetails',
    element: <EmployeeDetails />,
    layout: 'default',
  },
  {
    path: '/UpdateEmployeePerformancedata2',
    element: <UpdateEmployeePerformancedata2 />,
    layout: 'default',
  },
  {
    path: '/QualityControl/superAudit/SuperAuditRebuttal',
    element: <SuperAuditRebuttalMainFile />,
    layout: 'default',
  },

  {
    path: '/QualityControl/superAudit/SuperAuditFyiStatusRebuttal',
    element: <SuperAuditFyiStatusRebuttalMainFile />,
    layout: 'default',
  },

  ,
  {
    path: '/QualityControl/superAudit/RebuttalSuperAuditView',
    element: <SuperAuditRebuttalView />,
    layout: 'default',
  },
  {
    path: 'BiReports/MainReports',
    element: <MainReports />,
    layout: 'default',
  },

  {
    path: '/QualityControl/superAudit/RebuttalSuperAuditFyiStatusView',
    element: <RebuttalSuperAuditFyiStatusView />,
    layout: 'default',
  },
  {
    path: '/QualityControl/superAudit/SuperAuditDailyReport',
    element: <SuperAuditDailyReport />,
    layout: 'default',
  },
  {
    path: '/QualityManagerDashboard',
    element: <QMDashboardMain />,
    layout: 'default',
  },
  {
    path: '/ScopeMgmt/ScopeView/PasswordManager',
    element: (
      <>
        <PasswordManager />
      </>
    ),
  },
  {
    path: '/ScopeMgmt/ScopeView/PasswordManager/passwords/create',
    element: <CreatePassword />,
    layout: 'default',
  },
  {
    path: '/ScopeMgmt/ScopeView/PasswordManager/passwords/edit/:id',
    element: <EditPassword />,
    layout: 'default',
  },
  {
    path: '/ClientProtocol/ClientProtocols',
    element: <ClientProtocols />,
    layout: 'default',
  },
  //  {
  //   path: '/Incentive',
  //   element: <Incentive />,
  //   layout: 'default',
  // },
  {
    path: '/Ratings',
    element: <Ratings />,
    layout: 'default',
  },
  {
    path: '/AssistantManagerRatings',
    element: <AssistantManagerRatings />,
    layout: 'default',
  },
  {
    path: '/test/emptypage',
    element: <EmptyPage />,
    layout: 'default',
  },
  {
    path: '/ArCategoryException',
    element: <ArCategoryException />,
    layout: 'default',
  },
  {
    path: '/ArCategoryExceptionAudit',
    element: <ArCategoryExceptionAudit />,
    layout: 'default',
  },

  // {
  //   path: '/MessengerMain',
  //   element: <MessengerMain />,
  //   layout: 'default',
  // },
  {
    path: '/RecognitionRewards',
    element: <RecognitionRewards />,
    layout: 'default',
  },
  {
    path: '/AwardCategory',
    element: <AwardCategory />,
    layout: 'default',
  },
  {
    path: '/RedeemMain',
    element: <RedeemMain />,
    layout: 'default',
  },
  {
    path: '/EmployeRewards',
    element: <EmployeRewards />,
    layout: 'default',
  },
  {
    path: '/SuperAuditMTDReport',
    element: <SuperAuditMTDReport />,
    layout: 'default',
  },
  {
    path: '/WorkForceMgmt',
    element: <WorkForceManagement />,
    layout: 'default',
  },
  {
    path: '/public/top5carousel',
    element: <PublicTop5Carousel />,
    layout: 'blank',
  },
  {
    path: '/EprWhiteList',
    element: <EprWhiteList />,
    layout: 'default',
  },
  {
    path: '/EPR/Feedback',
    element: <Ticket />,
    layout: 'default',
  },
  {
    path: '/EPR/Holidays',
    element: <Holiday />,
    layout: 'default',
  },
  //  {
  //     path: '/UnifiedContactProfile',
  //     element: <UnifiedContactProfile />,
  //     layout: 'default',
  //   },
  {
    path: '/ExpiredPassword',
    element: <ExpiredPassword />,
    layout: 'default',
  },
  {
    path: '/DailyTracker',
    element: <DailyTracker />,
    layout: 'default',
  },
  {
    path: '/AssitantMangerAuditorError',
    element: <AssitantMangerAuditorError />,
    layout: 'default',
  },
];
